import axios from "axios";
import { Toast } from "vant";
import { handleUnAuth } from '../common/common';
Toast.allowMultiple();
const logina = axios.create({
  baseURL: process.env.NODE_ENV == "production" ? "" : "/authLog",
});

const handleError = (error) => {
  // console.log(error);
  Toast((error && error.data.message) || "未知错误");
};

logina.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    const language = localStorage.getItem('language');
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["ypSource"] = "H5";
    if (language) {
      config.headers["Language"] = language;
    }
    if (process.env.NODE_ENV == "production" && window.location.hostname == 'gcps.basf.com') {
      var url = config.url.startsWith("/") ? config.url.slice(1) :config.url;
      var baseUrl = '/big_canteen';
      config.url = baseUrl + url 
    }
    return config;
  },
  (error) => {
    handleError(error);
    return Promise.reject(error);
  }
);

logina.interceptors.response.use(
  function(response) {
    // Do something with response data
    const resData = response;
    if (resData && resData.data.code == 200) {
      return resData;
    } else if (resData && resData.data.code == 401) {
      // let url = localStorage.getItem("homeUrl");
      // sessionStorage.clear();
      // localStorage.clear();
      // return (window.location.href = url);
      handleUnAuth();
      return Promise.reject(resData);
    } else {
      handleError(resData);
      return Promise.reject(resData);
    }
  },
  function(error) {
    // Do something with response error
    // Message.error(error && error.message || '服务器异常');
    handleError(error);
    return Promise.reject(error);
  }
);

export default logina;
